import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { PrimeNgModule } from "@primeng";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PatientSwitchComponent } from "./patient-switch.component";
import { PlayerSharedModule } from "@project/player/player-shared.module";

@NgModule({
    declarations: [PatientSwitchComponent],
    imports: [
        CommonModule,
        PrimeNgModule,
        OverlayPanelModule,
        ReactiveFormsModule,
        MiproSharedModule,
        PlayerSharedModule
    ],
    exports: [PatientSwitchComponent]
})
export class PatientSwitchModule {}
